import React from 'react';
import moment from 'moment';
import { toDateFormat } from 'utils/date';
import WorkoutItem from 'features/work-out/components/workoutItem';

class WorkoutHistoryList extends React.Component {
  render() {
    let { logsList, clientId } = this.props;
    return (
      <ul className="workout-history-list">
        {
          logsList.map(log => {
            return(
              <li key={log.id}>
                <WorkoutItem
                  title={log.created_at && moment(toDateFormat(log.created_at)).format('L')}
                  desc={`${log.name}, ${log.level} Phase ${log.phase}`}
                  LinkTo={`/clients/${clientId}/workout-log/${log.id}`}
                />
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default WorkoutHistoryList;
